import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from './slices/counter';
import appReducer from './slices/app';
import dialogReducer, { toggle as toggleDialog, show as showDialog } from './slices/dialog';
import userReducer, { login } from './slices/user';
import pageReducer from './slices/page';
import dataReducer, { loadData, setData, submitData, requestFromAPI } from './slices/data';
import snackbarReducer, { toggle, show as showSnackbar } from './slices/snackbar';
import phoneReducer, { loadSIPAccount } from './slices/phone';

export const store = configureStore({
  reducer: {
    app: appReducer,
    counter: counterReducer,
    dialog: dialogReducer,
    user: userReducer,
    page: pageReducer,
    snackbar: snackbarReducer,
    data: dataReducer,
    phone: phoneReducer,
  },
});

export const rootActionCreators = {
  data: {
    load: loadData,
    set: setData,
    submit: submitData,
    requestFromAPI: requestFromAPI,
  },
  app: {

  },
  page: {

  },
  dialog: {
    toggle: toggleDialog,
    show: showDialog,
  },
  snackbar:{
    toggle,
    show: showSnackbar,
  },
  user: {
    login,
  },
  phone: {
    loadSIPAccount,
  }
}

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
